import { createSelector } from '@ngrx/store';
import { supplierFeature } from './supplier.reducer';

export const {
  selectSuppliers,
  selectIsLoading,
  selectError,
  selectBlends,
  selectBlendsLoading,
  selectBlendsError,
  selectBlendFormMode,
  selectSelectedBlendId,
  selectBlendSaving,
  selectBlendSaveError,
  selectGroupTemplates,
  selectGroupTemplatesLoading,
  selectGroupTemplatesError,
  selectGroupTemplateSaving,
  selectGroupTemplateSaveError,
  selectSupplierState,
} = supplierFeature;

export const selectAllBlendsLocked = createSelector(
  selectBlends,
  (blends) => blends.length > 0 && blends.every((blend) => blend.isLocked),
);

export const selectCurrentBlend = createSelector(
  selectBlends,
  selectSelectedBlendId,
  (blends, selectedBlendId) =>
    blends.find((blend) => blend.id === selectedBlendId) ?? null,
);
